import { useState, useRef, useEffect } from 'react'

const DelayedInput = ({
    value: initialValue = '',
    placeholder = '',
    isTextArea = false,
    updateAutomatically = true,
    onUpdate = () => {},
    inputRef,
    ...props
}) => {
    const [value, setValue] = useState(initialValue)
    const [isDirty, setIsDirty] = useState(false)
    const timerRef = useRef(null)

    useEffect(() => {
        setValue(initialValue)
        setIsDirty(false)
    }, [initialValue])

    const update = () => {
        if (isDirty) {
            setIsDirty(false)
            callbackOnUpdate()
        }
    }

    const onChange = event => {
        setValue(event.target.value)
        setIsDirty(true)
        startUpdating()
    }

    const onBlur = () => {
        update()
    }

    const onKeyPress = event => {
        if (event.key === 'Enter' && !updateAutomatically) {
            update()
        }
    }

    const startUpdating = () => {
        if (!updateAutomatically) return

        clearTimeout(timerRef.current)
        timerRef.current = setTimeout(update, 1000)
    }

    const callbackOnUpdate = () => {
        onUpdate(value)
    }

    const TextField = isTextArea ? 'textarea' : 'input'

    return (
        <TextField
            {...props}
            value={value || ''}
            onChange={onChange}
            onBlur={onBlur}
            onKeyPress={onKeyPress}
            ref={inputRef}
        />
    )
}

export default DelayedInput
